import React, {Component} from 'react'
import QuestionForm from "../../components/questionForm";
import {Switch, Route} from 'react-router-dom';
import {bindActionCreators} from "redux";
import {getQuestions} from "../../thunks";
import connect from "react-redux/es/connect/connect";
import NoMatch from "../../components/noMatch";


class Voter extends Component {

    componentWillMount() {
        this.props.getQuestions(this.props.match.params.hash);
    }

    render() {

        return (
            <Switch>
                <Route exact path={`${process.env.PUBLIC_URL}/:hash`} component={QuestionForm}/>
                <Route exact path={`${process.env.PUBLIC_URL}/:hash/:mark(1|2|3)`} component={QuestionForm}/>
                <Route exact path={`${process.env.PUBLIC_URL}/:hash/odeslano`} component={QuestionForm}/>
                <Route exact path={`${process.env.PUBLIC_URL}/:hash/chyba`} component={QuestionForm}/>
                <Route component={NoMatch} />
            </Switch>
        );
    }

}

const mapStateToProps = ({router, voter}) => ({
    mark: voter.get('mark'),
});

const mapDispatchToProps = dispatch => bindActionCreators({
    getQuestions,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Voter);



// WEBPACK FOOTER //
// ./src/containers/voter/index.js